import { useQuery } from "react-query";
import axios from "axios";
import { useState, useContext } from "react";
import "./examlanding.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { BrandButton } from "../components/form/buttons";
import AppHeader from "../components/appheader";
import { AppDataContext, ctxDefinition } from "../components/ctx";
import { useNavigate } from "react-router-dom";
import { ApiEndpoint } from "../components/utils";
import { pageIds } from "../components/utils";
import NetworkError from "../components/networkError";
import { Checkbox } from "@mui/material";

interface PageResponse {
  headerTitle?: string;
  welcomeMessage?: any;
}

const ExamLanding = () => {
  const navigate = useNavigate();
  const [data, setdata] = useState<PageResponse | null>();
  const [hasError, setHasError] = useState(false);
  const { userData, setExamSectionStartTime } = useContext(
    AppDataContext
  ) as ctxDefinition;
  const [confirm, setConfirm] = useState(false);
  const [networkError, setNetworkError] = useState(false);

  const { isLoading, error } = useQuery("registerPageData", async () => {
    try {
      const resp = await axios.get(
        ApiEndpoint +
          "wp-json/firstchoiceprep/v1/getPageText?slug=" +
          pageIds.exam_start
      );
      setdata(resp.data as PageResponse);
    } catch (e) {
      // handle network error
      setNetworkError(true);
    }
  });

  const beginExam = async () => {
    const newTime = new Date().getTime();
    const resp = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/setSectionStartTime",
      {
        token: userData.token,
        sectionId: userData.currentSectionId,
        timestamp: newTime,
      }
    );
    if (!resp || !resp.data.success) {
      setHasError(true);
      return;
    }

    const resp2 = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["examStarted"],
        values: [true],
      }
    );
    if (!resp2 || !resp2.data.success) {
      setHasError(true);
      return;
    }

    setExamSectionStartTime(newTime);
    navigate("/question/" + userData.examAnswers[0].questions[0].questionId, {
      replace: true,
    });
  };

  if (networkError) return <NetworkError open={true} />;

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;
  if (!userData) return <LoadError />;

  return (
    <div className="examLandingPage">
      <AppHeader />
      <div className="headline">
        <h1>{data?.headerTitle}</h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }}
        />
      </div>
      <div className="disclaimerHolder">
        <Checkbox onClick={() => setConfirm(!confirm)} />
        <p>
          Click the checkbox to confirm that you can read these characters in
          red <span>𝑓(𝑥) = 14𝑥³</span> as{" "}
          <em>
            f(x) = 14x<sup>3</sup>
          </em>
          . <br />
          If you cannot, please use a different browser to take this test as you
          will not be able to see many of the characters on the math sections of
          the test.
        </p>
      </div>
      <div className="btnHolder">
        <BrandButton disabled={!confirm} onClick={beginExam}>
          BEGIN
        </BrandButton>
      </div>
      <NetworkError open={hasError} />
    </div>
  );
};

export default ExamLanding;
